export var AFRAME_CDN_ROOT = window.AFRAME_CDN_ROOT || 'https://cdn.aframe.io/';
export var AFRAME_INJECTED = 'aframe-injected';
export var DEFAULT_CAMERA_HEIGHT = 1.6;
export var DEFAULT_HANDEDNESS = 'right';
